import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from "vuex";
import { OnlsThemeToggle } from "onls-core";

export default /*#__PURE__*/_defineComponent({
  __name: 'theme-toggle',
  setup(__props) {

const { state, commit } = useStore();
const toggleTheme = () => {
  commit("setTheme", state.theme === "light" ? "dark" : "light");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(OnlsThemeToggle), {
    theme: _unref(state).theme,
    "onUpdate:theme": toggleTheme
  }, null, 8, ["theme"]))
}
}

})